function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-credit-control_svg__cls-2{fill:none;stroke:var(--main-color);stroke-linecap:round;stroke-linejoin:round;stroke-width:8px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-credit-control_svg__Layer_1",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M195.12 62.79a4.61 4.61 0 014.6 4.6V198.2a4.6 4.6 0 01-4.6 4.59H64.31a4.6 4.6 0 01-4.59-4.59V67.39a4.6 4.6 0 014.59-4.6h130.81m0-8H64.31a12.6 12.6 0 00-12.59 12.6V198.2a12.59 12.59 0 0012.59 12.59h130.81a12.59 12.59 0 0012.6-12.59V67.39a12.6 12.6 0 00-12.6-12.6z",
  fill: "var(--main-color)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon-credit-control_svg__cls-2",
  cx: 119.04,
  cy: 115.84,
  r: 41
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-credit-control_svg__cls-2",
  transform: "rotate(-42.33 162.912 165.406)",
  d: "M152.91 141.05h20v48.71h-20z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-credit-control_svg__cls-2",
  d: "M100.04 115.84l15 17M138.04 96.84l-23 36"
}));

function SvgIconCreditControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 259 259"
  }, props), _ref, _ref2);
}

export default SvgIconCreditControl;